import React, { useEffect, useState } from "react";
import Hero from "../components/Hero";
import WigCard from "../components/WigCard";
import "./Home.css";
import { apiFetch } from "../utils/api";

export default function Home() {
  const [wigs, setWigs] = useState([]);

  useEffect(() => {
    apiFetch("/api/wigs")
      .then((r) => r.json())
      .then((data) => setWigs(data));
  }, []);

  return (
    <div className="home">
      <Hero />
      <div className="wigs-section">
        <div className="section-header">
          <h2>Our Premium Wig Collection</h2>
          <p>Choose from our wide range of quality wigs and hairpieces</p>
        </div>
        <div className="wig-list">
          {wigs.map((w) => (
            <WigCard key={w._id} wig={w} />
          ))}
        </div>
      </div>
    </div>
  );
}
